
import Vue from "vue";

import { SsoResponse } from "@shared/models";

import { getUserName } from "@/common/axshare";
import { sortDirectoryTree } from "@/common/fs";
import { getUserDirectoryTree } from "@/services/fs.service";
import { DirectoryTreeNode } from "@/services/models";
import { AxShare } from "@/store/state";

import AxTree from "@/components/AxTree.vue";
import { TreeNode } from "@/components/types/AxTree";

export default Vue.extend({
  components: {
    AxTree,
  },

  props: {
    value: {
      type: String,
      default: null,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    showAll: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      active: [this.value],
      workspacesRoot: undefined as DirectoryTreeNode | undefined,
    };
  },

  computed: {
    user(): SsoResponse | undefined {
      const { user } = this.$store.state as AxShare;
      return user.userInfo;
    },

    tree(): TreeNode[] {
      if (!this.workspacesRoot) return [];
      return this.generate(this.workspacesRoot).children;
    },
  },

  async created() {
    this.loading = true;
    try {
      this.workspacesRoot = (await getUserDirectoryTree()).workspacesRoot;
    } catch {
      //
    }
    this.loading = false;
  },

  methods: {
    generate(node: DirectoryTreeNode): TreeNode<DirectoryTreeNode> {
      const hasChildren = node.children && node.children.length > 0;
      const showAll = this.showAll;
      const children = hasChildren
        ? sortDirectoryTree(node.children)
          .filter(n => showAll || this.userIsOwner(n) || n.explicitlyJoined)
          .map(this.generate)
        : [];
      return {
        id: node.id,
        name: node.name,
        data: node,
        children,
      };
    },

    getOwnerDescription(node: DirectoryTreeNode) {
      if (!this.userIsOwner(node)) {
        return `(Owner: ${this.getUserName(node.owner)})`;
      }
      return "";
    },

    userIsOwner(node: DirectoryTreeNode) {
      if (this.user) {
        return this.user.userId === node.owner.userId;
      }
      return false;
    },

    getUserName(user: SsoResponse): string {
      return getUserName(user) || user.userEmail || "";
    },

    selected(items: any) {
      const selected = this.multiple ? items : items[0];
      this.$emit("input", selected);
    },
  },
});
